import {createSelector} from 'reselect';
import {getLocale} from './system';
import {getMap, getSystem, getTranslations} from './store';
import {getGeoCode, getGeography, getPropertyMapThumbnailUrl, getPropertyNotes} from './listing';
import {getLocation} from './listingSummary';

const getLocationDescription = createSelector(
    [getPropertyNotes],
    (propertyNotes = []) => {
        for (let note of propertyNotes) {
            if (note.title === 'Local Description' && note.text && note.text.trim().length) {
                return note.text;
            }
        }

        return null;
    }
);

const getMapData = createSelector(
    [
        getLocale,
        getLocation,
        getLocationDescription,
        getMap,
        getGeoCode,
        getGeography,
        getSystem,
        getTranslations,
        getPropertyMapThumbnailUrl
    ],
    (
        locale,
        locationLabel,
        locationDescription,
        map,
        geoCode,
        geography,
        system,
        translations,
        propertyMapThumbnailUrl
    ) => {
        const mapRegion = locale.substring(3, 5);
        const location = (geography && geography.location) || {};
        const geo = geoCode || {};
        const lat = geo.latitude || location.lat;
        const lng = geo.longitude || location.lng;
        const exact = !!(geo.latitude && geo.longitude && geo.exact);

        return {
            unveiled: map.unveiled,
            exact,
            lat,
            lng,
            locationDescription,
            mapApiKey: map.apiKey,
            mapLanguage: locale,
            propertyMapThumbnailUrl,
            mapRegion,
            labels: {
                openMap: translations.openMap,
                map: translations.navMap,
                location: locationLabel,
                more: translations.more
            },
            siteName: system.siteName
        };
    }
);

export default getMapData;
export {getMapData, getLocationDescription};
